export default [
  {
    "type": "access_control:edit",
    "title": "Предоставляет полный доступ в сервис access_control"
  },
  {
    "type": "access_control:read",
    "title": "Предоставляет доступ на чтение данных из сервиса access_control"
  },
  {
    "type": "access_management:edit",
    "title": "Предоставляет полный доступ в сервис access_management"
  },
  {
    "type": "access_management:read",
    "title": "Предоставляет доступ на чтение данных из сервиса access_management"
  },
  {
    "type": "ad:edit",
    "title": "Предоставляет полный доступ в сервис ad"
  },
  {
    "type": "ad:read",
    "title": "Предоставляет доступ на чтение данных из сервиса ad"
  },
  {
    "type": "audit:edit",
    "title": "Предоставляет полный доступ в сервис audit"
  },
  {
    "type": "audit:read",
    "title": "Предоставляет доступ на чтение данных из сервиса audit"
  },
  {
    "type": "banner:edit",
    "title": "Предоставляет полный доступ в сервис banner"
  },
  {
    "type": "banner:read",
    "title": "Предоставляет доступ на чтение данных из сервиса banner"
  },
  {
    "type": "bell:edit",
    "title": "Предоставляет полный доступ в сервис bell"
  },
  {
    "type": "bell:read",
    "title": "Предоставляет доступ на чтение данных из сервиса bell"
  },
  {
    "type": "dadata:edit",
    "title": "Предоставляет полный доступ в сервис dadata"
  },
  {
    "type": "dadata:read",
    "title": "Предоставляет доступ на чтение данных из сервиса dadata"
  },
  {
    "type": "device:edit",
    "title": "Предоставляет полный доступ в сервис device"
  },
  {
    "type": "device:read",
    "title": "Предоставляет доступ на чтение данных из сервиса device"
  },
  {
    "type": "dial:edit",
    "title": "Предоставляет полный доступ в сервис dial"
  },
  {
    "type": "dial:read",
    "title": "Предоставляет доступ на чтение данных из сервиса dial"
  },
  {
    "type": "ecosystem:edit",
    "title": "Предоставляет полный доступ в сервис ecosystem"
  },
  {
    "type": "ecosystem:read",
    "title": "Предоставляет доступ на чтение данных из сервиса ecosystem"
  },
  {
    "type": "encryption_profile:edit",
    "title": "Предоставляет полный доступ в сервис encryption_profile"
  },
  {
    "type": "encryption_profile:read",
    "title": "Предоставляет доступ на чтение данных из сервиса encryption_profile"
  },
  {
    "type": "event:edit",
    "title": "Предоставляет полный доступ в сервис event"
  },
  {
    "type": "event:read",
    "title": "Предоставляет доступ на чтение данных из сервиса event"
  },
  {
    "type": "exchange:edit",
    "title": "Предоставляет полный доступ в сервис exchange"
  },
  {
    "type": "exchange:read",
    "title": "Предоставляет доступ на чтение данных из сервиса exchange"
  },
  {
    "type": "identity:edit",
    "title": "Предоставляет полный доступ в сервис identity"
  },
  {
    "type": "identity:read",
    "title": "Предоставляет доступ на чтение данных из сервиса identity"
  },
  {
    "type": "identity_b2b:edit",
    "title": "Предоставляет полный доступ в сервис identity_b2b"
  },
  {
    "type": "identity_b2b:read",
    "title": "Предоставляет доступ на чтение данных из сервиса identity_b2b"
  },
  {
    "type": "invoice:edit",
    "title": "Предоставляет полный доступ в сервис invoice"
  },
  {
    "type": "invoice:read",
    "title": "Предоставляет доступ на чтение данных из сервиса invoice"
  },
  {
    "type": "jwks:edit",
    "title": "Предоставляет полный доступ в сервис jwks"
  },
  {
    "type": "jwks:read",
    "title": "Предоставляет доступ на чтение данных из сервиса jwks"
  },
  {
    "type": "kms:edit",
    "title": "Предоставляет полный доступ в сервис kms"
  },
  {
    "type": "kms:read",
    "title": "Предоставляет доступ на чтение данных из сервиса kms"
  },
  {
    "type": "multiapp:edit",
    "title": "Предоставляет полный доступ в сервис multiapp"
  },
  {
    "type": "multiapp:read",
    "title": "Предоставляет доступ на чтение данных из сервиса multiapp"
  },
  {
    "type": "notification:edit",
    "title": "Предоставляет полный доступ в сервис notification"
  },
  {
    "type": "notification:read",
    "title": "Предоставляет доступ на чтение данных из сервиса notification"
  },
  {
    "type": "omnichat:edit",
    "title": "Предоставляет полный доступ в сервис omnichat"
  },
  {
    "type": "omnichat:read",
    "title": "Предоставляет доступ на чтение данных из сервиса omnichat"
  },
  {
    "type": "preset:edit",
    "title": "Предоставляет полный доступ в сервис preset"
  },
  {
    "type": "preset:read",
    "title": "Предоставляет доступ на чтение данных из сервиса preset"
  },
  {
    "type": "rfidregistry:edit",
    "title": "Предоставляет полный доступ в сервис rfidregistry"
  },
  {
    "type": "rfidregistry:read",
    "title": "Предоставляет доступ на чтение данных из сервиса rfidregistry"
  },
  {
    "type": "signal:edit",
    "title": "Предоставляет полный доступ в сервис signal"
  },
  {
    "type": "signal:read",
    "title": "Предоставляет доступ на чтение данных из сервиса signal"
  },
  {
    "type": "subscription:edit",
    "title": "Предоставляет полный доступ в сервис subscription"
  },
  {
    "type": "subscription:read",
    "title": "Предоставляет доступ на чтение данных из сервиса subscription"
  },
  {
    "type": "tag:edit",
    "title": "Предоставляет полный доступ в сервис tag"
  },
  {
    "type": "tag:read",
    "title": "Предоставляет доступ на чтение данных из сервиса tag"
  },
  {
    "type": "telemetry_alerting:edit",
    "title": "Предоставляет полный доступ в сервис telemetry_alerting"
  },
  {
    "type": "telemetry_alerting:read",
    "title": "Предоставляет доступ на чтение данных из сервиса telemetry_alerting"
  },
  {
    "type": "telemetry_control:edit",
    "title": "Предоставляет полный доступ в сервис telemetry_control"
  },
  {
    "type": "telemetry_control:read",
    "title": "Предоставляет доступ на чтение данных из сервиса telemetry_control"
  },
  {
    "type": "telemetry_metric:edit",
    "title": "Предоставляет полный доступ в сервис telemetry_metric"
  },
  {
    "type": "telemetry_metric:read",
    "title": "Предоставляет доступ на чтение данных из сервиса telemetry_metric"
  },
  {
    "type": "telemetry_status:edit",
    "title": "Предоставляет полный доступ в сервис telemetry_status"
  },
  {
    "type": "telemetry_status:read",
    "title": "Предоставляет доступ на чтение данных из сервиса telemetry_status"
  },
  {
    "type": "user:edit",
    "title": "Предоставляет полный доступ в сервис user"
  },
  {
    "type": "user:read",
    "title": "Предоставляет доступ на чтение данных из сервиса user"
  },
  {
    "type": "vc:edit",
    "title": "Предоставляет полный доступ в сервис vc"
  },
  {
    "type": "vc:read",
    "title": "Предоставляет доступ на чтение данных из сервиса vc"
  },
  {
    "type": "watchdog:edit",
    "title": "Предоставляет полный доступ в сервис watchdog"
  },
  {
    "type": "watchdog:read",
    "title": "Предоставляет доступ на чтение данных из сервиса watchdog"
  }
];
